
<template>
    <div>
    <template >
      <form  data-vv-scope="submittForm">
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="form_group">
                <template v-if="isEVerifyErrs">
                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius "
                         active="true">
                        <p >{{ eVerifyErrs['message'] }}</p>
                        <ul class="errors_list" v-for="err in eVerifyErrs['error']" :key="err.error_code">
                          <li>{{ err.message }} </li>
                        </ul>
                    </vs-alert> 
               </template>
             <template v-else>   
              <template v-if="!callFromPetitionerDetails">
                <p v-if="(checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId')  || checkProperty(this.caseDetails, 'tenantDetails', 'eVerifyClientId') )">
                  Are you sure you want to file the I-9 in E-Verify Portal?
                </p>
                <!-- <p  v-else>Are you sure you want to file the I-9 in E-Verify Portal?</p> -->
              </template>
              <immiInput v-if="!(checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId') || checkProperty(this.caseDetails, 'tenantDetails', 'eVerifyClientId')) " 
              :wrapclass="'md:w-full'" :allowUpperCase="true" :display="true" :required="true" :onlyNumbers="true" :allowFloatingPoint="false" :fieldsArray="[]" maxvalueData="alpha_num|min:7|max:7" cid="eVerifyNumber" formscope="submittForm" v-model="eVerifyNumber" :maxLength="7" :fieldName="'eVerifyNumber'"   label="I-9 E-Verify Client ID" placeHolder="I-9 E-Verify number" :onlyDigits="true" />
            </template> 
            </div>
            </div>
          </div>
        </div>
        <div class="popup-footer">
          <figure v-if="loading" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
          <vs-button color="dark" @click="hideMe" class="cancel" type="filled">Cancel</vs-button>
          <vs-button v-if="!(checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId') || checkProperty(this.caseDetails, 'tenantDetails', 'eVerifyClientId')  )" color="success" @click="[1].indexOf(getTenantTypeId) > -1 ? lawfirmEverify() : corporateEverify()" class="save" type="filled">{{eVerifyUpdate ? 'Update' : 'Submit'}}</vs-button>
          <vs-button v-if="!isEVerifyErrs &&checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId') || checkProperty(this.caseDetails, 'tenantDetails', 'eVerifyClientId') " color="success" @click="submitToEverify()" class="save" type="filled">Yes</vs-button>
        </div>
       </form>
      </template> 

      <eVerifyDuplicates v-if="isDuplicateCase" :eVerifyDataDuplicates="eVerifyDataDuplicates" @hideDuplicates="hideDuplicates"/>

      </div>
    
  </template>
  <script>
  import eVerifyDuplicates from '@/views/i-9Module/actionsFlow/actionsComponents/eVerifyDuplicates.vue'
  import Vue from 'vue';
  Vue.use( CKEditor );
  import CKEditor from '@ckeditor/ckeditor5-vue2';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import quillTextEditor from "@/views/forms/fields/quillTextEditor.vue";
  import immiInput from "@/views/forms/fields/simpleinput.vue"
  import moment from 'moment'
  export default {
    inject: ["parentValidator"],
    created() {
        this.$validator = this.parentValidator;
    },
    methods: {
      hideDuplicates(){
        this.isDuplicateCase=false
        this.$emit("hideMe");
      },
      lawfirmEverify() {
           this.formErrors ='';
           this.$validator.validateAll("submittForm").then((result) => {
              if (result) {
               let postData={
              "companyId": this.callFromPetitionerDetails? this.companyId : this.checkProperty(this.caseDetails, 'companyId'),
              "eVerifyClientId": this.eVerifyNumber 
               }
                 this.loading =true;
                 let path ="/company/update-everify-client-id";
                 this.$store
                .dispatch("commonAction", {"data":postData ,"path":path})
                .then(response => {
                  this.$emit("updatepetition", "Success");
                  this.$emit("hideMe");  
                  this.showToster({message:response.message,isError:false });
                  // if(this.eVerifyUpdate == false){
                  //   this.submitToEverify()
                  // }
                           
                })
                .catch((error)=>{
                  this.showToster({message:error,isError:true });
                  this.loading =false;
                  this.formErrors =error;
                })
              }
            });
      },
      submitToEverify(){
        this.formErrors ='';
               let postData={
              "i9Id":this.checkProperty(this.caseDetails, '_id'),
              "eVerifyClientId": [1].indexOf(this.getTenantTypeId) > -1 ?this.checkProperty(this.caseDetails, 'petitionerDetails', 'eVerifyClientId') :this.checkProperty(this.caseDetails, 'tenantDetails', 'eVerifyClientId')
               }
                 this.loading =true;
                 let path ="/i9/create-case-in-everify";
                 this.$store
                .dispatch("commonActionWithErrorData", {"data":postData ,"path":path})
                .then(response => {
                  this.$emit("updatepetition");
                  this.$emit("hideMe");  
                  this.showToster({message:response.message,isError:false });         
                })
                .catch((error)=>{
                  console.log(error['results'])
                  if(this.checkProperty(error, 'error', 'length') > 1){
                    this.isEVerifyErrs=true
                    this.eVerifyErrs = error
                    this.loading =false;
                  }
                  else if(this.checkProperty(error, 'results')){
                    this.showToster({message:error['message'],isError:true });
                    this.eVerifyDataDuplicates = error['results']
                    this.isDuplicateCase=true
                    this.loading =false;
                  }
                  else{
                  this.loading =false;
                  this.formErrors =error;
                  this.showToster({message:error['error'][0]['message'] ,isError:true });
                  }
                  
                })
      },
      corporateEverify() {
           this.formErrors ='';
           this.$validator.validateAll("submittForm").then((result) => {
              if (result) {
               let postData={
              "tenantId": this.callFromPetitionerDetails? this.companyId : this.checkProperty(this.caseDetails, 'tenantId'),
              "eVerifyClientId": this.eVerifyNumber 
               }
                 this.loading =true;
                 let path ="/tenant/update-everify-client-id";
                 this.$store
                .dispatch("commonAction", {"data":postData ,"path":path})
                .then(response => {
                  this.$emit("updatepetition", "Success");
                  this.$emit("hideMe");  
                  this.showToster({message:response.message,isError:false });
                  // if(this.eVerifyUpdate == false){
                  //   this.submitToEverify()
                  // }        
                })
                .catch((error)=>{
                  this.showToster({message:error,isError:true });
                  this.loading =false;
                  this.formErrors =error;
                })
              }
            });
      },
      hideMe() {
        this.$emit("hideMe");
      },
    },
    watch: {
      showPopup(val) {
        if (!val) this.$emit("hideMe");
      },
    },
    mounted() {
      if(this.eVerifyUpdate){
        this.heading = 'Update I-9 E-Verify Client ID'
        this.eVerifyNumber = this.eVerifyID
      }
    },
    data: () => ({
      editor: ClassicEditor,
      editorConfig: {
          toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
      },
      eVerifyDataDuplicates:null,
      isDuplicateCase:false,
      eVerifyErrs:[],
      isEVerifyErrs:false,
      heading:'Add I-9 E-Verify Client ID',
      eVerifyNumber:null,
      formErrors:"",
      loading:false,
      showPopup: false,
      comments: '',
      formerrors: {
      msg: "",
      },
      }),
    props: {
      caseDetails: {
        type: Object,
        default: null,
      },
      companyId:{
          type:String,
          default:'',
      },
      callFromPetitionerDetails:{
          type: Boolean,
          default: false, 
      },
      eVerifyUpdate:{
        type:Boolean,
        default:false,
      },
      eVerifyID:{
        type:String,
        default:''
      },
      isCorporate:{
        type:Boolean,
        default:false,
      }
    },
  components: {
    immiInput,
    quillTextEditor,
    eVerifyDuplicates
  },
  };
  </script>